import propTypes from 'prop-types';
import React from 'react';

IconDetails.propTypes = {
  iconDetails: propTypes.object,
};

export default function IconDetails({ iconDetails }) {
  const { icon, title, description, step, img } = iconDetails;

  return (
    <div className="icon-details-card">
      <div className="icon-title-container">
        {step && <div className="card-step">{step}</div>}
        {icon && <img src={icon} alt={title} />}
        <h3>{title}</h3>
        {img && <img className="problem-image" src={img} alt={img} />}
      </div>
      {description && <p>{description}</p>}
    </div>
  );
}
